export default function atualizarAgendamentoPublicDTO({ DATA, IDHORARIO, IDCADASTRO, IDESPECIALIDADE }) {
  return {
    DATA,
    IDHORARIO,
    IDCADASTRO,
    IDESPECIALIDADE,

    // Campos internos  
    CANCELADA: false,
    REALIZADO: false,
    PAGO: false,
    FALTA:false,
    TIPOAGENDAMENTO: "C"
  };
}